import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace AKCCAT {
  export const form: IEventRegisterRow[] = [
    {
      inputs: [
        {
          type: "dropdown",
          label: "Are you planning to earn a title?",
          id: "plan_to_earn_title",
          options: [
            { value: "No", id: "no" },
            { value: Constants.akc_cat_titles.ca, id: Constants.akc_cat_titles.ca },
            { value: Constants.akc_cat_titles.caa, id: Constants.akc_cat_titles.caa },
            { value: Constants.akc_cat_titles.cax, id: Constants.akc_cat_titles.cax },
            { value: Constants.akc_cat_titles.cax2, id: Constants.akc_cat_titles.cax2 }
          ]
        }
      ]
    },
    {
      inputs: [
        {
          type: "checkbox",
          label: "Is your dog Brachycephalic?",
          id: "is_brachycephalic",
          multiSelect: false,
          options: [
            { value: "Yes", id: "true" }
          ]
        }
      ]
    }
  ];
}

